import React from 'react';
import { Base64ImageEncoder } from '../components/base64-image-encoder/Base64ImageEncoder';

export const Base64ImageEncoderPage: React.FC = () => {
  return (
    <div className="page-container">
      <Base64ImageEncoder />
    </div>
  );
};